module.exports = __webpack_public_path__ + "static/media/GongXiang1.67999f1d.png";